const SECTION_DRAFT_STORAGE_PREFIX = 'rt.sectionDraft.v1';

export function getSectionDraftStorageKey(testId: number, sectionId: number): string {
    const resolvedTestId = Number(testId || 0);
    const resolvedSectionId = Number(sectionId || 0);
    return `${SECTION_DRAFT_STORAGE_PREFIX}:${resolvedTestId}:${resolvedSectionId}`;
}

export function clearSectionDraft(testId: number, sectionId: number): void {
    localStorage.removeItem(getSectionDraftStorageKey(testId, sectionId));
}
